export const selectRequirementsDaysRange = {
    bindings: {
        identifier: '@'
    },
    template: require('./select-requirements-days-range.html'),
    controller: 'SelectRequirementsDaysRangeController'
};
